const SEO_REDIRECTS_BASE_ROUTE = '/settings/seo-redirects';

export const seoRedirectsRoutes = {
  redirects: SEO_REDIRECTS_BASE_ROUTE,
};
